import { render } from "./TraineePay.vue?vue&type=template&id=48a4d8ca&scoped=true"
import script from "./TraineePay.vue?vue&type=script&setup=true&lang=js"
export * from "./TraineePay.vue?vue&type=script&setup=true&lang=js"

import "./TraineePay.vue?vue&type=style&index=0&id=48a4d8ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a4d8ca"],['__file',"src/views/course/TraineePay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48a4d8ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48a4d8ca', __exports__)) {
    api.reload('48a4d8ca', __exports__)
  }
  
  module.hot.accept("./TraineePay.vue?vue&type=template&id=48a4d8ca&scoped=true", () => {
    api.rerender('48a4d8ca', render)
  })

}


export default __exports__